import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgCrop = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M26.25 21a.875.875 0 0 1-.875.875h-3.5v3.5a.875.875 0 1 1-1.75 0v-3.5H7A.875.875 0 0 1 6.125 21V7.875h-3.5a.875.875 0 0 1 0-1.75h3.5v-3.5a.875.875 0 0 1 1.75 0v17.5h17.5a.875.875 0 0 1 .875.875ZM10.5 7.875h9.625V17.5a.875.875 0 1 0 1.75 0V7A.875.875 0 0 0 21 6.125H10.5a.875.875 0 1 0 0 1.75Z" />
  </svg>
);
export default SvgCrop;
